module.exports = __webpack_public_path__ + "img/img-text-1.1f60a83e.png";